import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60bfd8e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "jumbotrons" }
const _hoisted_2 = {
  align: "center",
  class: "jumbotron"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  id: "continue_div"
}
const _hoisted_8 = {
  id: "counters",
  align: "left"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { align: "center" }, "Checker status", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "list-group" }
const _hoisted_12 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Working proxies")
const _hoisted_14 = {
  class: "badge badge-success badge-pill",
  id: "working_proxies"
}
const _hoisted_15 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Dead proxies")
const _hoisted_17 = {
  id: "dead_proxies",
  class: "badge badge-danger badge-pill"
}
const _hoisted_18 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Total proxies")
const _hoisted_20 = { class: "badge badge-secondary badge-pill" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = {
  id: "table_checking",
  class: "table table-hover"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "IP"),
    /*#__PURE__*/_createElementVNode("th", null, "Port"),
    /*#__PURE__*/_createElementVNode("th", null, "Country"),
    /*#__PURE__*/_createElementVNode("th", null, "Proxy Type")
  ])
], -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = ["src"]
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = { key: 5 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { saveProxies, state } from '@/composables/proxy-checker';

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable-next-line vue/no-setup-props-destructure */


export default /*#__PURE__*/_defineComponent({
  props: {
  total: Number,
  wProxies: Number,
  dProxies: Number,
},
  setup(__props) {

const props = __props



const getFlag = (flag: any) => `https://flagcdn.com/h20/${flag.toLowerCase()}.webp`;

const onDownload = () => {
  // console.log('w->', state.working_proxies_list);

  saveProxies(state.working_proxies_list);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(state).loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      (_unref(state).isShow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("ul", _hoisted_11, [
                _createElementVNode("li", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(props.wProxies), 1)
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(props.dProxies), 1)
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(props.total), 1)
                ])
              ]),
              _hoisted_21,
              _hoisted_22
            ]),
            _createElementVNode("table", _hoisted_23, [
              _hoisted_24,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).response, (ip) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: _normalizeClass(ip.working ? 'table-success' : 'table-danger'),
                  key: ip.ind
                }, [
                  (ip.working === true)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_25, "Working"))
                    : (_openBlock(), _createElementBlock("td", _hoisted_26, "Dead")),
                  _createElementVNode("td", null, _toDisplayString(ip.ip), 1),
                  _createElementVNode("td", null, _toDisplayString(ip.port), 1),
                  (ip.working === true)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                        _createElementVNode("img", {
                          src: getFlag(ip.country),
                          alt: ""
                        }, null, 8, _hoisted_28)
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_29, "unknown")),
                  (ip.working === true)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(ip.type), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_31, "unknown"))
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(state).isShow)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            id: "proxy_button",
            class: "btn",
            onClick: onDownload,
            style: {"display":"inline"}
          }, " Download proxies"))
        : _createCommentVNode("", true),
      _hoisted_32,
      _hoisted_33
    ])
  ]))
}
}

})